import classes from "./Splatnet.module.css"
import Modal from "../../../components/UI/Modal/Modal"
import { useBoolState, decrypt_key, dict_length, useLocalStorage, encrypt_key } from "../../../Utils"
import { defaultGearList, defaultImportData } from "../../../DefaultEntries"
import { faUpload, faFileImport, faFileCode, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useState, useCallback, useMemo, useEffect } from "react"
import headData from "../../../assets/json/parameters/GearInfoHead.json"
import clothesData from "../../../assets/json/parameters/GearInfoClothes.json"
import shoesData from "../../../assets/json/parameters/GearInfoShoes.json"
import { useTranslation, Trans } from "react-i18next"
import Input from "../../../components/UI/Input/Input"

const Splatnet = props => {
    const { t } = useTranslation()

    const [uploadOpen, onOpen, onClose] = useBoolState()
    const [enterReplayCode, onOpen2, onClose2] = useBoolState()
    const [gearList, setGearList] = useLocalStorage("gearList", defaultGearList)
    const [userData, setUserData] = useLocalStorage("importData", defaultImportData)

    const updateGearList = useCallback(
        newDB => {
            const heads = { ...gearList.HaveGearHeadMap }
            const clothes = { ...gearList.HaveGearClothesMap }
            const shoes = { ...gearList.HaveGearShoesMap }
            const old_db = { ...gearList }

            old_db.HaveGearHeadMap = Object.assign(heads, newDB.HaveGearHeadMap)
            old_db.HaveGearClothesMap = Object.assign(clothes, newDB.HaveGearClothesMap)
            old_db.HaveGearShoesMap = Object.assign(shoes, newDB.HaveGearShoesMap)

            setGearList(old_db)
        },
        [gearList, setGearList]
    )

    const addUserData = useCallback(
        newDB => {
            const old_db = { ...userData }
            old_db.UserKey = newDB.Key
            old_db.H = newDB.H
            old_db.LastImported = newDB.LastImported
            setUserData(old_db)
            props.renderAgain()
        },
        [userData, setUserData, props]
    )

    const onUpload = useCallback(
        newDB => {
            updateGearList(newDB)
            addUserData(newDB)
            onClose()
        },
        [onClose, updateGearList, addUserData]
    )

    const onUpload2 = useCallback(
        newDB => {
            addUserData(newDB)
            onClose()
        },
        [onClose, addUserData]
    )

    return (
        <>
            <div className={classes.cardWrapperWrapper}>
                <div className={classes.cardWrapper}>
                    <div className={classes.Subtitle}>
                        <h6 className={classes.Subtitleh6}>{t("misc:Common.ImportFromSplatnet")}</h6>
                    </div>
                    <hr className={classes.Divider} />
                    <div className={classes.CardContent}>
                        <div className={classes.CardDark}>
                            <div>
                                <strong>{t("misc:Database.SplatnetInstructions")}</strong>
                                <h4>{t("misc:Database.SeedKeyOnly")}</h4>
                                <p>
                                    <Trans
                                        i18nKey="misc:Database.Credits"
                                        defaults={"Thanks to <0>Ellie</0> for the replay lookup endpoint."}
                                        components={[
                                            // eslint-disable-next-line
                                            <a href="https://github.com/samuelthomas2774/splatoon3-replay-lookup" />,
                                        ]}
                                    />
                                </p>
                                <ul>
                                    <li>{t("misc:Database.SeedKeyOnlyStep1")}</li>
                                    <li>{t("misc:Database.SeedKeyOnlyStep2")}</li>
                                </ul>
                                <div>
                                    <div style={{ marginTop: 16 }}>
                                        <Modal show={enterReplayCode} modalClosed={onClose2} wide={true}>
                                            <ReplayCard onReplace={onUpload2} />
                                        </Modal>
                                        <button onClick={onOpen2} className={classes.ButtonInfo}>
                                            <FontAwesomeIcon icon={faMagnifyingGlass} />{" "}
                                            <span style={{ padding: 6 }}>
                                                {t("misc:Database.EnterReplayCode")}
                                                {
                                                    //t("misc:Common.SearchReplay")
                                                }
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                <hr className={classes.Divider} />
                                <h4>{t("misc:Database.SeedKeyAndGear")}</h4>
                                {/* <h5>English only</h5>
                                <p>Thanks to the Developers of Spyke Bot, you now have an alternative way to get the file.</p>
                                <ul>
                                    <li>
                                        Find the Spyke Bot on Discord.(For example <a href="https://discordapp.com/invite/q2j8HtB">here</a>)
                                    </li>
                                    <li>
                                        Send a private message to Spyke Bot with content <code>/s3gear</code>
                                    </li>
                                    <li>Follow the instructions and upload the resulting JSON file here.</li>
                                </ul>
                                <h5>International</h5>
                                <ul>
                                    <li>
                                        <Trans
                                            i18nKey="misc:Database.SplatnetInstructionsStep1"
                                            defaults={
                                                "Find the Lanista Bot on Discord. (For example on the <0>Sendou.ink Discord</0> or <1>LUTI Discord</1>.)"
                                            }
                                            components={[
                                                // eslint-disable-next-line
                                                <a href="https://discord.gg/dgYZW4bqep" />,
                                                // eslint-disable-next-line
                                                <a href="https://discord.gg/dgYZW4bqep" />,
                                            ]}
                                        />
                                    </li>
                                    <li>
                                        <Trans
                                            i18nKey="misc:Database.SplatnetInstructionsStep2"
                                            defaults={"Send a private message to the Lanista Bot with content <0>{{command, string}}</0>."}
                                            components={[<code />]}
                                            values={{ command: t("other:Command.Lanista") }}
                                        />
                                    </li>
                                    <li>{t("misc:Database.SplatnetInstructionsStep3")}</li>
                                </ul> */}
                                <h5>Manual Only</h5>
                                Please follow instructions at <a href="https://github.com/frozenpandaman/s3s">s3s</a> to get your json file.
                                Follow instructions from <a href="https://github.com/frozenpandaman/s3s/issues/198">this issue</a> to get
                                your token.
                            </div>
                            <div>
                                <div style={{ marginTop: 16 }}>
                                    <Modal show={uploadOpen} modalClosed={onClose} wide={true}>
                                        <UploadCard onReplace={onUpload} gearList={gearList} />
                                    </Modal>
                                    <button onClick={onOpen} className={classes.ButtonInfo}>
                                        <FontAwesomeIcon icon={faUpload} /> <span style={{ padding: 6 }}>{t("misc:Common.Upload")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const UploadCard = props => {
    const { t } = useTranslation()

    const [data, setdata] = useState("")
    const [filename, setfilename] = useState("")
    const [errorMsg, setErrorMsg] = useState("")

    const onUpload = async e => {
        const file = e.target.files[0]
        e.target.value = null // reset the value so the same file can be uploaded again...
        if (file) setfilename(file.name)
        const reader = new FileReader()
        reader.onload = () => setdata(reader.result)
        reader.readAsText(file)
    }

    const importedDatabase = useMemo(() => {
        if (!data) return
        let parsed
        try {
            parsed = JSON.parse(data)
            if (typeof parsed !== "object") {
                setErrorMsg(t("misc:Database.ErrorJSONParse"))
                return
            }
        } catch (e) {
            setErrorMsg(t("misc:Database.ErrorJSONParse"))
            return
        }
        let tmp_data = parsed
        let head, clothes, shoes
        if (!("key" in tmp_data) || !("h" in tmp_data) || !("timestamp" in tmp_data) || !("gear" in tmp_data)) {
            setErrorMsg(t("misc:Database.ErrorInvalidFormat"))
            return
        }

        if (!("headGears" in tmp_data.gear.data) || !("clothingGears" in tmp_data.gear.data) || !("shoesGears" in tmp_data.gear.data)) {
            setErrorMsg(t("misc:Database.ErrorInvalidFormat"))
            return
        }

        // validate key
        if (decrypt_key(tmp_data.key, tmp_data.h) === undefined) {
            setErrorMsg(t("misc:Database.ErrorInvalidFormat"))
            return
        }

        head = tmp_data.gear.data.headGears.nodes
        clothes = tmp_data.gear.data.clothingGears.nodes
        shoes = tmp_data.gear.data.shoesGears.nodes

        const use_head = {}
        const use_clothes = {}
        const use_shoes = {}
        const gearList = props.gearList
        for (const elem of head) {
            const h = headData.filter(e => e.Id === parseInt(elem.headGearId))
            const c = gearList.HaveGearHeadMap[elem.headGearId]
            if (h.length > 0 && c === undefined) {
                const skills = elem.additionalGearPowers.map(e => e.gearPowerId & 0xff).filter(e => e !== 0xff)
                use_head[elem.headGearId] = {
                    ExSkillArray: skills,
                    ExDrinksArray: skills.map(() => 0xff),
                    MainSkill: elem.primaryGearPower.gearPowerId,
                    RandomContext: 0,
                }
            }
        }
        for (const elem of clothes) {
            const h = clothesData.filter(e => e.Id === parseInt(elem.clothingGearId))
            const c = gearList.HaveGearClothesMap[elem.clothingGearId]
            if (h.length > 0 && c === undefined) {
                const skills = elem.additionalGearPowers.map(e => e.gearPowerId & 0xff).filter(e => e !== 0xff)
                use_clothes[elem.clothingGearId] = {
                    ExSkillArray: skills,
                    ExDrinksArray: skills.map(() => 0xff),
                    MainSkill: elem.primaryGearPower.gearPowerId,
                    RandomContext: 0,
                }
            }
        }
        for (const elem of shoes) {
            const h = shoesData.filter(e => e.Id === parseInt(elem.shoesGearId))
            const c = gearList.HaveGearShoesMap[elem.shoesGearId]
            if (h.length > 0 && c === undefined) {
                const skills = elem.additionalGearPowers.map(e => e.gearPowerId & 0xff).filter(e => e !== 0xff)
                use_shoes[elem.shoesGearId] = {
                    ExSkillArray: skills,
                    ExDrinksArray: skills.map(() => 0xff),
                    MainSkill: elem.primaryGearPower.gearPowerId,
                    RandomContext: 0,
                }
            }
        }
        setErrorMsg("")
        return {
            HaveGearHeadMap: use_head,
            HaveGearClothesMap: use_clothes,
            HaveGearShoesMap: use_shoes,
            LastImported: tmp_data.timestamp,
            Key: tmp_data.key,
            H: tmp_data.h,
        }
    }, [data, props.gearList, t])

    const replaceDB = useCallback(() => {
        if (!importedDatabase) return
        setdata("")
        setfilename("")
        props.onReplace(importedDatabase)
    }, [importedDatabase, props])

    return (
        <>
            <div className={classes.CardContent}>{t("misc:Common.ImportFromSplatnet")}</div>
            <div className={classes.CardContent}>
                <div className={classes.GridStyle}>
                    <div style={{ paddingLeft: 16, paddingTop: 16 }}>
                        <label>
                            <input id="icon-button-file" accept=".json" type="file" style={{ display: "none" }} onChange={onUpload} />

                            <span className={classes.ButtonDefault}>
                                <FontAwesomeIcon icon={faFileImport} style={{ marginRight: 8 }} />
                                {t("misc:Database.ButtonOpen")}
                            </span>
                        </label>
                    </div>
                    <div style={{ paddingLeft: 16, paddingTop: 16 }}>
                        <div style={{ paddingLeft: 16, paddingTop: 6 }}>
                            {filename ? (
                                <span>
                                    <FontAwesomeIcon icon={faFileCode} style={{ marginRight: 8 }} /> {filename}
                                </span>
                            ) : (
                                <span>{t("misc:Database.UploadJson")}</span>
                            )}
                        </div>
                    </div>
                </div>
                <div></div>
                <span className={classes.TextTiny}>{t("misc:Database.UploadJsonPath")}</span>
                <textarea value={data} onChange={e => setdata(e.target.value)}></textarea>
                {!importedDatabase ? (
                    errorMsg
                ) : (
                    <div style={{ marginTop: 16 }}>
                        <div>
                            <div>
                                {t("misc:Database.NewHeadGear")}: <strong>{dict_length(importedDatabase.HaveGearHeadMap)}</strong>
                            </div>
                            <div>
                                {t("misc:Database.NewClothesGear")}: <strong>{dict_length(importedDatabase.HaveGearClothesMap)}</strong>
                            </div>
                            <div>
                                {t("misc:Database.NewShoesGear")}: <strong>{dict_length(importedDatabase.HaveGearShoesMap)}</strong>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <hr className={classes.Divider} />
            <div className={classes.CardContent}>
                <button
                    className={importedDatabase ? classes.ButtonInfo : classes.ButtonDisabled}
                    disabled={!importedDatabase}
                    onClick={replaceDB}
                >
                    <FontAwesomeIcon icon={faUpload} /> <span style={{ padding: 6 }}>{t("misc:Common.UpdateDatabase")}</span>
                </button>
            </div>
        </>
    )
}

const ReplayCard = props => {
    const { t } = useTranslation()

    const [currentCode, setCurrentCode] = useState("")
    const [errorMsg, setErrorMsg] = useState("")
    const [data, setData] = useState({})

    function isEmpty(obj) {
        return Object.keys(obj).length === 0
    }

    useEffect(() => {
        setData({})
        setErrorMsg("")
        if (!currentCode) return
        const cc = currentCode.replace(/[^0-9A-Z]/g, "")
        if (cc.length !== 16) return
        fetch("https://splatoon3-replay-lookup.fancy.org.uk/api/splatnet3/replay/" + cc)
            .then(response => response.json())
            .then(response => {
                if ("error" in response) {
                    setErrorMsg(response["error_message"])
                    return
                }
                const nlpl_id = response["npln_user_id"]
                const [Key, H] = encrypt_key(nlpl_id)
                const username = `${response.replay.historyDetail.player.name}#${response.replay.historyDetail.player.nameId}`
                setErrorMsg(username)
                setData({
                    LastImported: Date.now(),
                    Key: Key,
                    H: H,
                })
            })
    }, [currentCode])

    const replaceDB = () => {
        if (isEmpty(data)) return
        setCurrentCode("")
        props.onReplace(data)
    }

    const replayValidator = elem => {
        let inputstr = elem.target.value.toUpperCase()

        inputstr = inputstr.replace(/[^0-9A-Z]/g, "")
        inputstr = inputstr.substring(0, 16) // cut off too many characters
        let fs = ""
        for (let i = 0; i < inputstr.length; i++) {
            if (i % 4 === 0 && i > 0) {
                fs += "-"
            }
            fs += inputstr[i]
        }
        if (inputstr.length % 4 === 0 && inputstr.length > 0 && inputstr.length < 16) {
            fs += "-"
        }
        setCurrentCode(fs)
    }

    return (
        <>
            <div className={classes.CardContent}>{t("misc:Database.ImportFromReplayCode")}</div>
            <div className={classes.CardContent}>
                <span className={classes.TextTiny}>{t("misc:Database.EnterReplayCode")}</span>
                <Input title={t("translation:LayoutMsg.Tml_Home_00.040")} changed={replayValidator} val={currentCode} />

                {errorMsg}
            </div>
            <hr className={classes.Divider} />
            <div className={classes.CardContent}>
                <button
                    className={!isEmpty(data) ? classes.ButtonInfo : classes.ButtonDisabled}
                    disabled={isEmpty(data)}
                    onClick={replaceDB}
                >
                    <FontAwesomeIcon icon={faMagnifyingGlass} /> <span style={{ padding: 6 }}>{t("misc:Database.AddKey")}</span>
                </button>
            </div>
        </>
    )
}

export default Splatnet

// {"variables":{},"extensions":{"persistedQuery":{"version":1,"sha256Hash":"61228d553e7463c203e05e7810dd79a7"}}}
// {"variables":{},"extensions":{"persistedQuery":{"version":1,"sha256Hash":"7d8b560e31617e981cf7c8aa1ca13a00"}}}
// {"variables":{},"extensions":{"persistedQuery":{"version":1,"sha256Hash":"d29cd0c2b5e6bac90dd5b817914832f8"}}}
